<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 监控中心 </el-breadcrumb-item>
          <el-breadcrumb-item>调控管理</el-breadcrumb-item>
          <el-breadcrumb-item>编辑调控</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content-box">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="编辑调控" name="account">
            <div class="tab-content">
              <el-form
                ref="editForm1"
                :model="model"
                :rules="rules"
                :label-position="labelPosition"
              >
                <el-form-item label="设备公司" label-width="120px">
                  <cn-select-search
                    style="text-align: left"
                    ref="child"
                    v-model="model.companyId"
                    :v_disabled="disabled"
                    :data="companyList"
                    @val="setCompanyId"
                    placeholder="请筛选客户..."
                  >
                  </cn-select-search>
                </el-form-item>
                <el-form-item label="请选择设备" label-width="120px">
                  <el-select
                    v-model="model.deviceId"
                    placeholder="请选择设备..."
                    class="sb_select"
                  >
                    <el-option
                      v-for="item in cabinetList"
                      :key="item.id"
                      :label="`${item.cabinetCode}  /  ${item.cabinetName}`"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="请选择时间"
                  label-width="120px"
                  v-if="flag"
                >
                  <el-date-picker
                    style="width: 220px"
                    v-model="model.planTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="footer-box">
        <div class="footer-btn">
          <el-button type="primary" @click="submitForm('editForm')"
            >确认保存</el-button
          >
          <el-button plain @click="resetForm">取消返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../js/upload.component.js";
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import { method } from "lodash";
import "../../js/select.component.js";
let self = this;
export default {
  data() {
    return {
      flag: true,
      disabled: true,
      activeName: "account", //当前选项卡
      labelPosition: "right", //表单对齐方式

      companyList: [], //公司列表
      form: {
        startTime: null,
        endTime: null,
      },
      cabinetList: [],
      model: {
        companyId: "",
        equipNo: "",
        deviceId: "",
        resourceType: 6,
        equipType: 9,
        source: "Fx",
        planTime: "",
      },
      type: 0, //1复制 2修改
      rules: {},
    };
  },
  methods: {
    getCabinetList: function (companyId) {
      let _this = this; //当前页面
      _this.cabinetList = [];
      //加载设备列表
      AxiosAjax({
        url: "/cabinet/cabinet/page?index=1&size=9000&companyId=" + companyId,
        loading: true,
        success: function (res) {
          _this.cabinetList = res.data.data.content;
        },
      });
    },
    //初始化数据
    initData: function () {
      let _this = this; //当前页面
      let id = _this.$route.query.id || ""; //获取ID
      this.type = _this.$route.query.type || ""; //获取ID
      let companyId = this.$route.params.companyId || "";
      if (companyId != "") {
        _this.model.companyId = this.$route.params.companyId;
      } else {
        _this.model.companyId =
          window.localStorage.getItem("fx_login_companyId");
      }
      _this.getCabinetList(_this.model.companyId);

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "0") {
        _this.disabled = false;
      }
    },
    submitForm: function () {
      let _this = this; //当前页面

      _this.cabinetList.forEach((item) => {
        if (item.id == _this.model.deviceId) {
          _this.model.equipNo = item.cabinetCode;
        }
      });
      if (this.$route.params.key === 1) {
        console.log("复制");
        console.log(_this.model);
        let obj = {
          companyId: _this.model.companyId,
          equipNo: _this.model.equipNo,
          deviceId: _this.model.deviceId,
        };
        AxiosAjax({
          url: "/cabinet/haiyi/plan/copy/" + _this.model.id,
          method: "post",
          data: obj,
          loading: true,
          success: function (res) {
            if (res.data.code == "000000") {
              setTimeout(() => {
                window.history.back(-1);
              }, 100);
              _this.$message({
                message: "复制成功",
                type: "success",
              });
            }
          },
        });
      } else {
        if (JSON.stringify(this.$route.params) !== "{}") {
          AxiosAjax({
            url: "/cabinet/haiyi/plan/" + _this.$route.params.id,
            method: "post",
            data: {
              companyId: _this.model.companyId,
              deviceId: _this.model.deviceId,
              planTime: _this.model.planTime,
              equipNo: _this.model.equipNo,
              resourceType: _this.model.resourceType,
              equipType: _this.model.equipType,
              source: _this.model.source,
            },
            loading: true,
            success: function (res) {
              console.log(res.data.code);
              if (res.data.code == "000000") {
                setTimeout(() => {
                  window.history.back(-1);
                }, 100);
                _this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
            },
          });
        } else {
          AxiosAjax({
            url: "/cabinet/haiyi/plan/",
            method: "post",
            data: _this.model,
            loading: true,
            success: function (res) {
              console.log(res.data.code);
              if (res.data.code == "000000") {
                setTimeout(() => {
                  window.history.back(-1);
                }, 100);
                _this.$message({
                  message: "新增成功",
                  type: "success",
                });
              }
            },
          });
        }
      }
    },
    resetForm() {
      window.history.back(-1);
    },

    setCompanyId: function (obj) {
      this.model.companyId = obj.toString();
      this.getCabinetList(this.model.companyId);
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
  mounted: function () {
    var _this = this;
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.model = this.$route.params;
    }
    _this.$refs.child.valueId = _this.model.companyId;
    _this.$refs.child.reset();
    if (this.$route.params.key === 1) {
      this.flag = false;
    }
  },
};
</script>
<style scoped>
.dl-box-fee .el-input {
  width: 20%;
}
.dl-box-fee /deep/ .el-form-item__label {
  min-width: 80px;
}
.dl-box .el-form-item__label {
  font-weight: bold;
}
.el-date-editor.el-input {
  width: 150px;
}
.myselect .el-input {
  width: 100px;
}
.card-form {
  display: flex;
}
.card-form /deep/ .el-col {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Regulation/RegulationEdit.vue